import { useQuery } from '@tanstack/react-query'

import { PermissionSet, useBusinessContext, useFeature, usePermission } from '@root/context'
import { fetchVerohallintoCertificateStatus } from '../integrations/verohallinto'

export const useVerohallintoCertificateStatus = () => {
  const { slug } = useBusinessContext()
  const hasPermission = usePermission(PermissionSet.REPORTING_ADMIN)
  const { enabled: vatExternalReporting } = useFeature('vat_external_reporting')
  const { enabled: omaveroEnabled } = useFeature('omavero')

  return useQuery({
    queryKey: [slug, 'verohallinto_certificate_status'],
    queryFn: () => fetchVerohallintoCertificateStatus({ slug }),
    ...{
      refetchInterval: 15000,
      staleTime: 15000,
      enabled: hasPermission && vatExternalReporting && omaveroEnabled
    }
  })
}
